import React from "react";

const Header = () => {
  let navLink = [
    { id: 1, label: "flex-direction" },
    { id: 2, label: "flex-wrap" },
    { id: 3, label: "justify-content" },
    { id: 4, label: "align-content" },
    { id: 5, label: "align-items" },
  ];
  return (
    <div className="main-header">
      <aside>
        <h1>Flexbox in CSS</h1>
        <h3>
          ‘Flexbox in CSS’ is a website that helps you determine what properties
          you need.
        </h3>
      </aside>
      <nav>
        <ul>
          {navLink.map(({ label }) => {
            return (
              <li>
                <a href={`#${label}`}>{label}</a>
              </li>
            );
          })}
        </ul>
      </nav>
    </div>
  );
};

export default Header;
